<template>
    <!-- 司机预警弹窗，不管在任何模块，只要登录系统了，接口返回需要帮助的通知，就弹窗 -->
    <el-dialog :visible.sync="show" width="40%" :before-close="closeDialog">
        <h2 style="text-align: center">帮助通知</h2>

        <p style="margin-top: 30px">{{ content }}</p>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">忽略</el-button>
            <el-button @click="toDetails" type="primary">去查看</el-button>
        </span>
    </el-dialog>
</template>
<script>
var _this;
import axios from 'axios'; // AJAX封装类
import bus from '@/components/common/bus';
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            this.content = this.data;
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,

            content: ''
        };
    },

    methods: {
        toDetails() {
            // 去查看
            _this.show = false;
            
            
            bus.$emit('poseMp3'); // 点击去查看 触发App.vue的方法，如果有播放的音频则暂停播放
            console.log('去查看按钮关闭音乐');
            // 如果不在司机预警模块下，跳转到 /driverAlert 路由

            if (this.$route.path !== '/driverAlert') {
                this.$router.push({
                    path: '/driverAlert'
                });
            } else {
                // 如果已经在 /driverAlert 路由，则可以执行其他操作或不做任何操作
                // console.log('Already on the /driverAlert route');
            }
        },

        // 关闭弹窗 忽略
        closeDialog() {
            _this.show = false;
            bus.$emit('poseMp3'); // 关闭司机预警弹窗，触发App.vue的方法，如果有播放的音频则暂停播放
            console.log('忽略按钮或关闭弹窗，按钮关闭音乐');

        }
    }
};
</script>
<style>
</style>